<template>
  <div class="header-container-wrap plr-110 flex flex-ai-center">
    <div class="header-container-left flex-1 flex flex-ai-center">
      <img
        @click="$router.push('/')"
        class="_logo pointer"
        src="@/assets/images/layout/logo.png"
        alt=""
      />
      <!-- <div class="location ml-20 flex flex-ai-center">
        <img src="@/assets/images/layout/location.png" alt="">
        <span class="ml-5 c-blue f-14">合肥市</span>
      </div> -->
    </div>
    <div
      v-if="isShow"
      class="header-container-right flex-1 flex flex-ai-center flex-jc-end"
    >
      <template v-if="isShow && this.$route.path != '/search'">
        <el-input
          v-model="inputValue"
          @change="toSearch"
          class="h-40 mr-15 w-600"
          placeholder="请输入产品/机构名称等关键词进行搜索"
        >
          <div slot="append" @click="toSearch">搜 索</div>
        </el-input>
      </template>
      <el-button @click="handleDialog" type="primary" class="h-40 f-16">
        免费委托下单
      </el-button>
    </div>
    <div
      v-if="!isShow && this.$route.path != '/login'"
      @click="$router.push('/index')"
      class="c-primary f-16 pointer"
    >
      返回首页
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeData } from "@/utils/auth";
export default {
  data() {
    return {
      inputValue: "",
    };
  },
  computed: {
    ...mapGetters(["userType"]),
    isShow() {
      return (
        ["/", "/index", "/search"].includes(this.$route.path) ||
        this.$route.path.indexOf("/modules") != -1
      );
    },
  },
  methods: {
    toSearch() {
      if (!this.inputValue) {
        this.$modal.msgWarning("请输入关键字");
        return;
      }
      this.$router.push({
        path: "/search",
        query: {
          title: this.inputValue,
        },
      });
      this.inputValue = "";
    },
    handleDialog() {
      if (this.userType == "user") {
        this.$router.push("/entrust");
      } else {
        this.$alert("需用户身份登录后操作！", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: true,
        })
          .then(() => {
            removeData();
            this.$router.push("/login");
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container-wrap {
  .location {
    background: #ebf7ff;
    border: 1px solid #14a1ff;
    border-radius: 5px;
    padding: 8px 14px;
    box-sizing: border-box;
  }
}

::v-deep .el-input__inner {
  border: none !important;
  background-color: #f7f7f7 !important;
  font-size: 12px;
}

::v-deep .el-input-group__append {
  background-color: #c00202;
  color: #ffffff;
  font-size: 16px;
  border-color: #c00202;
  cursor: pointer;
}

._logo {
  width: 210px;
}
</style>
